import PaginationControls from "../../../../../../components/base/PaginationControls";

interface TrackingReplaysPaginationProps {
  currentPage: number;
  totalPages: number;
  isDarkMode: boolean;
  onPageChange: (page: number) => void;
}

export function TrackingReplaysPagination({
  currentPage,
  totalPages,
  onPageChange,
}: TrackingReplaysPaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <div className="mt-6">
      <PaginationControls
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
      />
    </div>
  );
}
